export const mockAPIPath = {
    STUCKED_TRANSACTION:"./data/stuckedTransaction.json",
    DELETE_STUCKED_TRANSACTION:""
};

export const serverAPIPath = {
    STUCKED_TRANSACTION:"/stucked-transaction",
    DELETE_STUCKED_TRANSACTION:"/stucked-transaction"

};